<template>
  <div>
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text class="">
      <strong>Year</strong>
      <v-textarea
        label=""
        color="green"
        v-model="doc.year"
        :rows="1"
        :autoGrow="true"
        :hide-details="false"
      />
      <strong>Title</strong>
      <v-textarea
        label=""
        color="green"
        v-model="doc.title"
        :rows="1"
        :autoGrow="true"
        :hide-details="false"
      />
      <strong>Description</strong>
      <v-textarea
        label=""
        v-model.trim="doc.description"
        type="text"
        placeholder="Description"
        id="description"
        rows="2"
      ></v-textarea>
    </v-card-text>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "EmbedForm",
  props: {
    value: Object,
    name: String,
    title: String,
    doc: Object,
  },
};
</script>
